import { Program } from "../../models/Program";
import { api } from "../config/AxiosConfig";
import { MerchantGroup } from "../../models/MerchantGroup";
import { MerchantGroupLocation } from "../../models/MerchantGroupLocation";
import { CsrContact } from "../../models/CsrContact";
import { API_ROOT } from "./ApiUrlFormatter";
import { ReportGroup } from "../../models/ReportGroup";
import { Campaign } from "../../models/Campaign";
import { Ica } from "../../models/Ica";
import { Bin } from "../../models/Bin";
import { Country } from "../../models/Country";
import { Developer } from "../../models/Developer";
import { Portfolio } from "../../models/Portfolio";


const arrayToQueryString = (key: string, array: any ) => {
  if (!Array.isArray(array) || array.length === 0) {
    return '';
  }

  const params = array.map(value => {
    return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
  });

  return params.join("&");
};

export const ContactApi = {
  getPrograms: async () => {
    const response = await api.get<Program[]>(`${API_ROOT}/reporthub/programs`);
    return response;
  },

  getMerchantGroups: async (programId: number) => {
    const response = await api.get<MerchantGroup[]>(`${API_ROOT}/reporthub/programs/${programId}/merchantgroups`);
    return response;
  },

  getLocations: async (merchantGroupIds: string[]) => {
    let qs = arrayToQueryString("merchantGroupIds", merchantGroupIds);
    
    const response = await api.get<MerchantGroupLocation[]>(`${API_ROOT}/reporthub/locations?${qs}`);
    return response;
  },

  getCsrContacts: async (programId: number, merchantGroupId: number) => {        
    const response = await api.get<CsrContact[]>(`${API_ROOT}/reporthub/csrContacts?programId=${programId}&merchantGroupId=${merchantGroupId}`);
    return response;
  },

  getReportGroups: async (programId: number) => {
    const response = await api.get<ReportGroup[]>(`${API_ROOT}/reporthub/programs/${programId}/reportGroups`);
    return response;
  },

  getCampaigns: async (programId: number) => {
    const response = await api.get<Campaign[]>(`${API_ROOT}/reporthub/programs/${programId}/campaigns`);
    return response;
  },

  getIcas: async () => {
    const response = await api.get<Ica[]>(`${API_ROOT}/reporthub/icas`);
    return response;
  },

  getBins: async () => {
    const response = await api.get<Bin[]>(`${API_ROOT}/reporthub/bins`);
    return response;
  },

  getBankIds: async () => {
    const response = await api.get<number[]>(`${API_ROOT}/reporthub/banks`);
    return response;
  },
  
  getCountries: async () => {
    const response = await api.get<Country[]>(`${API_ROOT}/reporthub/countries`);
    return response;
  },

  getDevelopers: async () => {
    const response = await api.get<Developer[]>(`${API_ROOT}/reporthub/developers`);
    return response;
  },

  getDeveloperPrograms: async (developerUniqueTag: string) => {
    const response = await api.get<Program[]>(`${API_ROOT}/reporthub/developers/${developerUniqueTag}/programs`);
    return response;
  },

  getProgramMerchantGroups: async (programUniqueTag: string) => {
    const response = await api.get<MerchantGroup[]>(`${API_ROOT}/reporthub/programs/${programUniqueTag}/merchantgroups`);
    return response;
  },

  getPortfolios: async () => {
      const response = await api.get<Portfolio[]>(`${API_ROOT}/reporthub/portfolios`);
      return response;
  },

};
